module.exports = __webpack_public_path__ + "img/casino.85327551.png";